import {BaseLS} from './BaseLS';
import {IEnum} from '../../../@types/enum';

const STORAGE_KEY = 'subtitleLanguage';

export class SubtitleType extends BaseLS<IEnum> {
  constructor() {
    super(STORAGE_KEY);
  }
}
